import { ActionType } from '../../classes/calendar-actions';


export function requestPromoCodeApply() {
    return {
        type: ActionType.RequestPromoCodeApply
    }
}

export function updatePromoCodeString(promoCode: string) {
    return {
        type: ActionType.UpdatePromoCode,
        value: promoCode
    }
}

export function receivePromoCodeApplyResponse(promoCode: string, apiData: any) {
    return {
        type: ActionType.ReceivePromoCodeApply,
        value: {
            promoCode: promoCode,
            apiResponse: apiData
        }
    }
}

export function errorPromoCodeApply(error: any) {
    return {
        type: ActionType.ErrorPromoCodeApply,
        value: error
    }
}